import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { updateFacility } from '../../../actions/facilitiesActions'
import Button from '../../utils/Button'
import Card from '../../utils/Card'

const OutOfOrder = () => {
  const dispatch = useDispatch()
  const facility = useSelector(store => store.facilities.facility)
  const adminUser = useSelector(store => store.user.admin)

  const removeOutOfOrder = () => {
    dispatch(updateFacility(facility.id, { ooo: false }))
  }

  if (!facility.outOfOrder) {
    return null
  }

  return (
    <Card color="red" className="mt-6">
      <div className="flex justify-between">
        <h3 className="font-semibold text-xl mb-2">Facility Status Alert!</h3>
        {adminUser && (
          <Button size="xs" color="red" onClick={removeOutOfOrder}>
            Set Active
          </Button>
        )}
      </div>
      {facility.outOfOrderReason}
    </Card>
  )
}

export default OutOfOrder
